import React, {useEffect, useState} from 'react'
import WhitePlus from '../../../../media/felsv/white_plus-small_icon.svg'
import WhiteCheck from '../../../../media/felsv/white_check_icon.svg'
import DarkPorcentaje from '../../../../media/felsv/Porcentaje.svg'
import SecondaryPorcentaje from '../../../../media/felsv/PorcentajeSecondary.svg'
import DarkDollar from '../../../../media/felsv/Dollar.svg'
import DollarSecondary from '../../../../media/felsv/DollarSecondary.svg'
import {ProductosF} from '../../../../interfaces/facturacion.interface'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionProducto} from '../../../../actions/action-creators'
import {
  facturacionCloseModalEditar,
  facturacionFormProductoClear,
} from '../../../../actions/facturacion/facturacionProductos.actions'
import './styles/DatosProducto.css'
import DatosProductoSuma from './DatosProductoSuma'
import InputIcon from '../../../../components/Inputs/InputIcon'
import DatosSucursal from './DatosSucursal'
import ImgServicio from '../../../../media/felsv/dark_reader_icon.svg'
import ImgProducto from '../../../../media/felsv/dark_box_icon.svg'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import InputForm from '../../../OtrosDocumentos/Components/InputFormV2'
import InputSwitchDescripcion, { CheckBoxFlag } from '../../../OtrosDocumentos/Components/InputSwitchDescripcion'
import useUtilsDocs, { esCatalogoProductoByTipo } from '../../../../actions/utils-documentos.actions'
import { REGEX_HTML } from '../../../../constants/Regex'

const DatosProducto = (props: any) => {
  const formProducto: ProductosF = useSelector((state: State) =>
    props.editar ? state.facturacion.formProductosEdit : state.facturacion.formProductos
  )
  const esHtmlDescripcion = REGEX_HTML.test(`${formProducto.descripcion}`);

  const errors: ProductosF = useSelector((state: State) =>
    props.editar ? state.facturacion.errorsFormProductosEdit : state.facturacion.errorsFormProductos
  )
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFacturacionProducto, dispatch)
  const {unidadesMedida, productos: productosCatalogo} = useSelector(
    (state: State) => state.catalogos
  )
  const {processFormCatalogoProducto} = useUtilsDocs()
  const [customDescripcion, setCustomDescripcion] = useState(props.editar ? !formProducto.clave : false)
  const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);

  useEffect(() => {
    acciones.facturacionFormProductoUpdateCalculo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formProducto.cantidad,
    formProducto.precio,
    formProducto.descuento,
    formProducto.tipoDescuento,
  ])

  const agregarProducto = (e: any) => {
    e.preventDefault()
    setCustomDescripcion(false)
    acciones.facturacionFormProductoAddProducto()
  }

  const clear = () => {
    dispatch(facturacionFormProductoClear())
    setCustomDescripcion(false)
  }

  const closeModal = () => dispatch(facturacionCloseModalEditar())

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.facturacionFormProductoHandleChangeInput(e)
    acciones.facturacionFormProductoValidacionesOnBlur(e)
    if (e.target.name === 'descripcion' && e.target.value === '') {
      setCustomDescripcion(false)
    }
  }

  const handleSelectCatalogoProducto = (e: any) => {
    let newFormProducto = {...formProducto}
    if (e.label != -1) {
      newFormProducto = processFormCatalogoProducto(idDoc, formProducto, e.value)
    } else {
      newFormProducto = {
        ...newFormProducto,
        descripcion: e.value,
        clave: '',
        tributos: [],
        otrosImpuestos: '',
      }
      setCustomDescripcion(true);
      setCheckTextoEnrequecido(false);
    }

    if (props.editar) acciones.facturacionFormProductoHandleChangeEdit(newFormProducto)
    else acciones.facturacionFormProductoHandleChange(newFormProducto)
    acciones.facturacionFormProductoValidacionesOnBlur({
      target: {name: 'descripcion', value: e.value},
    })
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        {!props.editar && <DatosSucursal />}
        <form className='form-content' onSubmit={agregarProducto}>
          <div>
            <h3 className='card-title l'>PRODUCTO Ó SERVICIO</h3>
            <p className='m' style={{color: '#019FC5', margin: '2% 0', fontWeight: 'bold'}}>
              {idDoc === '01' && !formProducto.checkNoIva
                ? 'Los precios ingresados tienen que tener el IVA incluido'
                : ''}
            </p>
            <div className='form-separator'></div>
          </div>
          <TipoProducto editar={props.editar} />
          <div className='w-layout-hflex h-inputs'>
            {!customDescripcion && productosCatalogo.length > 0 ? (
              <InputForm
                enableCreate={true}
                required
                type='select'
                options={productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.tipo === "s", prod))}
                keyNameText='descripcion'
                keyNameValue='clave'
                onChange={handleSelectCatalogoProducto}
                label='Descripción'
                value={formProducto?.clave}
                error={errors.descripcion}
                componentSideLabel = {
                  <CheckBoxFlag 
                    label="Activar texto con formato" 
                    value={customDescripcion} 
                    onChange={() => {
                      setCustomDescripcion(true);
                      setCheckTextoEnrequecido(true);
                    }}
                  />
                }
              />
            ) : (
              <InputSwitchDescripcion
                autoFocus={props.editar ? true : false} 
                autoComplete='off'
                type='text' 
                defaultEnrequecido={esHtmlDescripcion || checkTextoEnrequecido} 
                className='m text-field w-input' 
                required 
                name='descripcion' 
                placeholder='Descripción del producto' 
                id='descripcion'
                maxLength={1000} 
                label='Descripción' 
                value={formProducto.descripcion} 
                error={errors.descripcion} 
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
            )}
          </div>
          <div className={`ef-form-producto-div4${props.editar ? '-modal' : ''}`}>
            <div className='label-input'>
              <label htmlFor='cantidad' className='field-label m'>
                Cantidad<span style={{color: 'red'}}>*</span>
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='cantidad'
                data-name=''
                placeholder='0'
                id='cantidad'
                maxLength={13}
                value={formProducto.cantidad}
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.cantidad && <p className='alert s'>{errors.cantidad}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='unidadMedida' className='field-label m'>
                Unidad de medida
              </label>
              <SearchSelect
                data={unidadesMedida}
                keyNameText='valor'
                keyNameValue='codigo'
                placeholder='Unidad de medida'
                value={formProducto.unidadMedida}
                onChange={(e) => handleChange({target: {value: e.value, name: 'unidadMedida'}})}
                name='unidadMedida'
                disabled={false}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='precio' className='field-label m'>
                Precio con IVA<span style={{color: 'red'}}>*</span>
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='precio'
                data-name=''
                placeholder='0.000'
                id='precio'
                value={formProducto.precio}
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.precio && <p className='alert s'>{errors.precio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDescuento' className='field-label m'>
                Tipo de desc.
              </label>
              <select
                id='tipoDescuento'
                name='tipoDescuento'
                data-name=''
                className='m text-field w-select'
                value={formProducto.tipoDescuento}
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              >
                <option value='porcentaje'>Porcentaje</option>
                <option value='monto'>Monto</option>
              </select>
              {errors.tipoDescuento && <p className='alert s'>{errors.tipoDescuento}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='descuento' className='field-label m'>
                Descuento
              </label>
              <InputIcon
                darkIcon={formProducto.tipoDescuento === 'porcentaje' ? DarkPorcentaje : DarkDollar}
                secondaryIcon={
                  formProducto.tipoDescuento === 'porcentaje'
                    ? SecondaryPorcentaje
                    : DollarSecondary
                }
                type='text'
                className={`text-field-icon2 ${
                  formProducto.tipoDescuento === 'porcentaje' ? 'porcentaje' : 'dollar'
                } w-input`}
                name='descuento'
                data-name=''
                placeholder='0.00'
                id='descuento'
                value={formProducto.descuento}
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.descuento && <p className='alert s'>{errors.descuento}</p>}
            </div>
          </div>
          <div className='form-separator'></div>
          <DatosProductoSuma
            exportacion={props.exportacion}
            subtotal={formProducto.subtotal}
            descuento={formProducto.cantidadDescuento}
            impuesto={formProducto.totalImpuesto1}
            otrosImpuestos={formProducto.otrosImpuestos}
            total={formProducto.total}
          />
          {props.editar ? (
            <div className='w-layout-hflex button-actions'>
              <button
                type='button'
                className='m button transparent w-inline-block'
                onClick={closeModal}
              >
                <div>Cancelar</div>
              </button>
              <button type='submit' className='m button w-inline-block'>
                <div>Actualizar</div>
                <img src={WhiteCheck} loading='lazy' alt='Generar' />
              </button>
            </div>
          ) : (
            <div className='w-layout-hflex button-actions'>
              <button type='button' className='m button transparent w-inline-block' onClick={clear}>
                <div>Limpiar</div>
              </button>
              <button type='submit' className='m button w-inline-block'>
                <img src={WhitePlus} loading='lazy' alt='Agregar' />
                <div>Agregar</div>
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  )
}

export default DatosProducto

const TipoProducto = (props: any) => {
  const formProducto: ProductosF = useSelector((state: State) =>
    props.editar ? state.facturacion.formProductosEdit : state.facturacion.formProductos
  )
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFacturacionProducto, dispatch)

  const handleChangeTipo = (value: string) => {
    acciones.facturacionFormProductoHandleChangeInput({target: {name: 'tipo', value}})
    if (value === 's')
      acciones.facturacionFormProductoHandleChangeInput({
        target: {name: 'checkNoIva', value: false},
      })
  }

  return (
    <div className='label-input'>
      <label htmlFor='tipo' className='field-label m'>
        Tipo de producto
      </label>
      <div className='div-block'>
        <button
          type='button'
          className={`product-type w-inline-block div-button ${
            formProducto.tipo === 'p' ? 'product-type-active' : ''
          }`}
          onClick={() => handleChangeTipo('p')}
        >
          <img src={ImgProducto} loading='lazy' alt='Producto' />
          <div>Producto</div>
        </button>
        <button
          type='button'
          className={`product-type w-inline-block div-button ${
            formProducto.tipo === 's' ? 'product-type-active' : ''
          }`}
          onClick={() => handleChangeTipo('s')}
        >
          <img src={ImgServicio} loading='lazy' alt='Servicio' />
          <div>Servicio</div>
        </button>
      </div>
    </div>
  )
}
